module.exports = __webpack_public_path__ + "static/tab_course_select.450d3775.png";